<app-delete-user [userType]="userType" [displayColumns]="displayedColumns" [route]="route"
    [userTypeToggleOptions]="userTypeToggleOptions"></app-delete-user>